export default __webpack_public_path__ + "static/map-pins-f4b060ec60e3b25ac2f00279e08edc68.png";